/**
 * Created by Daniel Wang on 07/01/2022.
 * Description:
 * workflow kanban wrapper
 * ------ maintenance history ------
*/

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { LayoutService } from '../../../services/layout.service';

@Component({
    selector: 'workflow-kanban-wrapper',
    templateUrl: './workflow-kanban-wrapper.component.html',
    styleUrls: ['./workflow-kanban-wrapper.component.scss']
})
export class WorkflowKanbanWrapperComponent implements OnInit, OnDestroy {
    //#region  public properties
    actionSubject$: Subject<any> = new Subject();
    id: string;
    instanceId: string;
    screenId = 'workflowView';
    taskId: string;
    workflowView = 'workflowView';
    //#endregion

    //#region private properties
    private _destroySubscriptions: Array<Subscription> = [];
    //#endregion

    //#region constructor
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _layoutService: LayoutService,
        private _route: ActivatedRoute,
    ) { }
    //#endregion

    //#region public functions
    ngOnInit() {
        // change the top of sub-chrome on the home page. needn't sub-chrome on workflow view.
        if (!this._changeDetectorRef['destroyed']) {
            // set the top of the sub-chrome, neen't sub-chrome in workflow, so set top as 55px (119-64)
            this._layoutService.changeSubTitleTopOpen$.next('64px');
        }
        this._destroySubscriptions.push(
            this._route.paramMap.pipe(
                skip(1)
            ).subscribe(() => this._initPage())
        );
        this._initPage();
    }

    ngOnDestroy() {
        // set the top of sub-chrome back to 119px (the default value).
        this._layoutService.changeSubTitleTopOpen$.next('119px');
    }
    //#endregion

    //#region private functions
    private _initPage() {
        // extract parameters from route.
        if (this._route.snapshot.paramMap.has('id') &&
            this._route.snapshot.paramMap.has('screenid')) {
            this.id = this._route.snapshot.paramMap.get('id');
            this.screenId = this._route.snapshot.paramMap.get('screenid');

            // used for workflow popup message. should open the specified task panel.
            if (this._route.snapshot.queryParams['task-id'] &&
                this._route.snapshot.queryParams['instance-id']) {
                this.taskId = this._route.snapshot.queryParams['task-id'];
                this.instanceId = this._route.snapshot.queryParams['instance-id'];
            }

            // notify the refresh subject.
            const screenInfo = {
                workflowId: this.id,
                screenId: this.screenId,
            };
            this.actionSubject$.next({
                type: 'REFRESH_WORKFLOW',
                payload: screenInfo
            });
        }
    }
    //#endregion
}
